/**
 * Created by fers on 28/04/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {FormattedMessage, IntlShape} from 'react-intl';
import config from '../../common/config';
import "./fakePanel.scss";
import MiniLogo from '../app/MiniLogo.react';

interface FakePanelProps {
    channelDefType?: string;
    children?: React.ReactNode;
    sourceDefType?: string;
}

export default class FakePanel extends React.Component<FakePanelProps> {

    static propTypes = {
        channelDefType: PropTypes.string,
        children: PropTypes.node,
        sourceDefType: PropTypes.string,
    };

    render() {
        let panelStyle = {};
        let panelImage = null;
        let pos = {width: 0, height: 0, left: 0, right: 0, bottom: 0};

        if (this.props.channelDefType) {
            if (this.props.channelDefType === "com.gmail") {
                panelImage = config.PUBLIC_CDN + "/logos/screenshots/gmail.png";
                pos = {width: 1251, height: 713, left: 56, right: 56, bottom: 74};
            } else if (this.props.channelDefType === "cz.merk") {
                panelImage = config.PUBLIC_CDN + "/logos/screenshots/merk-company.png";
                pos = {width: 879, height: 836, left: 0, right: 0, bottom: 0};
            } else if (this.props.channelDefType === "cz.fakturoid") {
                panelImage = config.PUBLIC_CDN + "/logos/screenshots/fakturoid.png";
                pos = {width: 1000, height: 800, left: 0, right: 0, bottom: 0};
            } else if (this.props.channelDefType === "eu.flexibee") {
                panelImage = config.PUBLIC_CDN + "/logos/screenshots/flexibee.png";
                pos = {width: 1000, height: 800, left: 0, right: 0, bottom: 0};
            } else if (this.props.channelDefType === "com.clevermonitor") {
                panelImage = config.PUBLIC_CDN + "/logos/screenshots/clevermonitor-contact.png";
                pos = {width: 1020, height: 800, left: 0, right: 0, bottom: 0};
            } else if (this.props.channelDefType === "cz.anabix") {
                panelImage = config.PUBLIC_CDN + "/logos/screenshots/anabix-contact.png";
                pos = {width: 1295, height: 857, left: 0, right: 0, bottom: 0};
            }
        }

		const tooltip = (
			<Tooltip id="tooltip"><FormattedMessage defaultMessage="Opens panel configuration" id="fakePanel.configButton" /></Tooltip>
		);


        if (panelImage) {
            let posLeft = (pos.left / pos.width) * 100.0;
            let posRight = (pos.right / pos.width) * 100.0;
            let posBottom = (pos.bottom / pos.height) * 100.0;
            panelStyle = {left: posLeft + '%', right: posRight + '%', bottom: posBottom + '%'};

			return (
				<div className="fake-panel-app fake-panel-app-with-img"  style={{maxWidth: pos.width}} >
					<img src={panelImage}/>
					<div className="fake-panel-wrapper" style={{paddingLeft: panelStyle.left, paddingRight: panelStyle.right}}>
						<div className="spanner"></div>
						<div className="fake-panel fake-panel-with-img">
							<div className="fake-panel-row">
								<div className="fake-panel-left">
									<ul>
										<li>
											<OverlayTrigger overlay={tooltip} placement="right">
												<i className="fa fa-fw fa-cog"></i>
											</OverlayTrigger>
										</li>
										<li><MiniLogo color width="35px" /></li>
									</ul>
								</div>
								<div className="fake-panel-right">
									{this.props.children}
								</div>
							</div>
						</div>
						<div className="spanner" style={{maxHeight: panelStyle.bottom}}></div>
					</div>
				</div>
			);
        }

        return (
            <div className="fake-panel-app">
                <div className="fake-panel fake-panel-no-img" style={panelStyle}>
                    <div className="fake-panel-row">
                        <div className="fake-panel-left">
                            <ul>
								<li>
									<OverlayTrigger overlay={tooltip} placement="right">
										<i className="fa fa-fw fa-cog"></i>
									</OverlayTrigger>
								</li>
                                <li><MiniLogo color width="35px" /></li>
                            </ul>
                        </div>
                        <div className="fake-panel-right">
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
